<template>
  <v-container fluid>
    <v-card class="pl-6 pr-6 pt-6 pb-6">
      <v-card-title>
        <v-row>
          <v-col cols="6" md="6" justify="center">
            <h3>Patent Matter</h3>
          </v-col>
          <v-col cols="6" md="6"></v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row justify="space-around" class="heightsize90formadvance">
          <v-col cols="12" sm="2" md="2">
            <h3><span class="vali">*</span>Object Type</h3>
            <v-autocomplete
              v-model="itemdata.tm_type"
              :items="objecttype_list"
              item-text="objecttype_code"
              item-value="objecttype_id"
              outlined
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <h3>Country</h3>
            <!-- <v-text-field v-model="itemdata.city" outlined dense></v-text-field> -->
            <v-autocomplete
              clearable
              @click:clear="
                $nextTick(() => {
                  itemdata.city = 0;
                })
              "
              v-model="itemdata.city"
              :items="country_list"
              item-text="enName"
              item-value="enName"
              outlined
              @change="onSelectCountryChange(showaddItem.country)"
              dense
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="1" md="1"></v-col>
          <v-col cols="12" sm="2" md="2">
            <h3>Client Reference</h3>
            <v-text-field
              v-model="itemdata.client_ref"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3><span class="vali">*</span>Client Name</h3>
            <v-text-field
              v-model="itemdata.name_of_client"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="space-around" class="heightsizemultiCo">
          <v-col cols="12" sm="2" md="2">
            <h3>Application No.</h3>
            <v-text-field
              v-model="itemdata.app_no"
              outlined
              dense
            ></v-text-field>
            <h3><span class="vali">*</span>File No.</h3>
            <v-text-field
              v-model="itemdata.file_no"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <h3>Application Date</h3>
            <v-menu
              v-model="menuaddAppD"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="itemdata.date_of_application"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    date_of_application = parseDate(
                      itemdata.date_of_application
                    )
                  "
                  @blur="
                    date_of_application = parseDate(
                      itemdata.date_of_application
                    )
                  "
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  clearable
                  @click:clear="
                    $nextTick(() => {
                      itemdata.date_of_application = '';
                    })
                  "
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="date_of_application"
                @input="menuaddAppD = false"
              ></v-date-picker>
            </v-menu>
            <h3>Type</h3>
            <v-autocomplete
              clearable
              @click:clear="
                $nextTick(() => {
                  itemdata.type = 0;
                })
              "
              v-model="itemdata.type"
              :items="type_list"
              item-text="type_name"
              item-value="type_number"
              outlined
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3" align="right"></v-col>
          <v-col cols="12" sm="1" md="1" align="right">
            <h3>Owner</h3>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-autocomplete
              clearable
              @click:clear="
                $nextTick(() => {
                  itemdata.owner_contact = 0;
                  owner_address = '';
                })
              "
              v-model="itemdata.owner_contact"
              :items="contact_owner_list"
              item-text="contact_name"
              item-value="contact_id"
              outlined
              dense
              @change="onSelectOwnerChange(itemdata.owner_contact)"
            ></v-autocomplete>
            <v-textarea
              v-model="owner_address"
              multi-line
              outlined
              dense
              background-color="#F5F5F5"
              disabled
              rows="4"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="space-around" class="heightsizemultiCo">
          <v-col cols="12" sm="4" md="4">
            <h3>Title</h3>
            <v-text-field
              v-model="itemdata.title"
              outlined
              dense
            ></v-text-field>
            <v-row justify="space-around">
              <v-col cols="12" sm="6" md="6">
                <h3>Patent No.</h3>
                <v-text-field
                  v-model="itemdata.patent_no"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <h3>Patent Date</h3>
                <v-menu
                  v-model="menuaddptd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="itemdata.date_of_patent"
                      persistent-hint
                      hint="Format DD/MM/YYYY"
                      @keydown.enter="
                        date_of_patent = parseDate(itemdata.date_of_patent)
                      "
                      @blur="
                        date_of_patent = parseDate(itemdata.date_of_patent)
                      "
                      append-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      clearable
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="date_of_patent"
                    @input="menuaddptd = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <h3>Priority Number</h3>
            <v-text-field
              v-model="itemdata.priority_number"
              outlined
              dense
            ></v-text-field>
            <v-row justify="space-around">
              <v-col cols="12" sm="12" md="12">
                <h3>Publishing Date</h3>
                <v-menu
                  v-model="menuaddpubd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="itemdata.date_of_publishing"
                      persistent-hint
                      hint="Format DD/MM/YYYY"
                      @keydown.enter="
                        date_of_publishing = parseDate(
                          itemdata.date_of_publishing
                        )
                      "
                      @blur="
                        date_of_publishing = parseDate(
                          itemdata.date_of_publishing
                        )
                      "
                      append-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      clearable
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="date_of_publishing"
                    @input="menuaddpubd = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="1" md="1" align="right"></v-col>
          <v-col cols="12" sm="1" md="1" align="right">
            <h3>Agent</h3>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-autocomplete
              clearable
              @click:clear="
                $nextTick(() => {
                  itemdata.agent_contact = 0;
                  agent_address = '';
                })
              "
              v-model="itemdata.agent_contact"
              :items="contact_agent_list"
              item-text="contact_name"
              item-value="contact_id"
              outlined
              dense
              @change="onSelectAgentChange(itemdata.agent_contact)"
            ></v-autocomplete>

            <v-textarea
              v-model="agent_address"
              multi-line
              outlined
              dense
              background-color="#F5F5F5"
              disabled
              rows="4"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="space-around" class="heightsizemultiCo200">
          <v-col cols="12" sm="2" md="2">
            <h3>Vol. No.</h3>
            <v-text-field
              v-model="itemdata.val_no"
              outlined
              dense
            ></v-text-field>
            <h3>Exam Request Deadline Date</h3>
            <v-menu
              v-model="menuadderdd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="itemdata.exam_request_deadline"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    exam_request_deadline = parseDate(
                      itemdata.exam_request_deadline
                    )
                  "
                  @blur="
                    exam_request_deadline = parseDate(
                      itemdata.exam_request_deadline
                    )
                  "
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  clearable
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="exam_request_deadline"
                @input="menuadderdd = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <h3>Page No.</h3>
            <v-text-field
              v-model="itemdata.page_no"
              outlined
              dense
            ></v-text-field>
            <br />
            <h3>Examination Date</h3>
            <v-menu
              v-model="menuaddeaxmd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="itemdata.date_of_examination"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    date_of_examination = parseDate(
                      itemdata.date_of_examination
                    )
                  "
                  @blur="
                    date_of_examination = parseDate(
                      itemdata.date_of_examination
                    )
                  "
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  clearable
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="date_of_examination"
                @input="menuaddeaxmd = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <h3>Exam Request Date</h3>
            <v-menu
              v-model="menuadderd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="itemdata.exam_request_date"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    exam_request_date = parseDate(itemdata.exam_request_date)
                  "
                  @blur="
                    exam_request_date = parseDate(itemdata.exam_request_date)
                  "
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  clearable
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="exam_request_date"
                @input="menuadderd = false"
              >
              </v-date-picker>
            </v-menu>
            <br />
            <h3>Next Deadline Date</h3>
            <v-menu
              v-model="menuaddndd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="itemdata.next_deadline"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    next_deadline = parseDate(itemdata.next_deadline)
                  "
                  @blur="next_deadline = parseDate(itemdata.next_deadline)"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  clearable
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="next_deadline"
                @input="menuaddndd = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="2" md="2" align="right">
            <h3>Associate</h3>
            <br /><br /><br />
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-autocomplete
              clearable
              @click:clear="
                $nextTick(() => {
                  itemdata.associate_contact = 0;
                  associate_address = '';
                })
              "
              v-model="itemdata.associate_contact"
              :items="contact_associate_list"
              item-text="contact_name"
              item-value="contact_id"
              outlined
              dense
              @change="onSelectAssociateChange(itemdata.associate_contact)"
            ></v-autocomplete>

            <v-textarea
              v-model="associate_address"
              multi-line
              outlined
              dense
              background-color="#F5F5F5"
              disabled
              rows="4"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="space-around" class="heightsizemultiCo180">
          <v-col cols="12" sm="5" md="5">
            <h3>Goods / Service</h3>
            <v-textarea
              v-model="itemdata.good_service"
              multi-line
              outlined
              dense
              rows="5"
            ></v-textarea>
          </v-col>
          <v-col cols="12" sm="1" md="1" align="right"></v-col>
          <v-col cols="12" sm="6" md="6">
            <h3>Registration Condition</h3>
            <v-textarea
              v-model="itemdata.registration_condition"
              multi-line
              outlined
              dense
              rows="5"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="space-around" class="heightsize90formadvance">
          <v-col cols="12" sm="2" md="2">
            <h3>Latest Annuity Paid</h3>
            <v-autocomplete
              clearable
              @click:clear="
                $nextTick(() => {
                  itemdata.dead_last_annuity_paid = '';
                })
              "
              v-model="itemdata.dead_last_annuity_paid"
              :items="latest_list"
              outlined
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Latest Annuity Paid Date</h3>
            <v-menu
              v-model="menuaddlapd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="itemdata.last_annuity_paid"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    last_annuity_paid = parseDate(itemdata.last_annuity_paid)
                  "
                  @blur="
                    last_annuity_paid = parseDate(itemdata.last_annuity_paid)
                  "
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  clearable
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="last_annuity_paid"
                @input="menuaddlapd = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="1" md="1"></v-col>
          <v-col cols="12" sm="3" md="3">
            <h3>Next Annuity Date</h3>
            <v-menu
              v-model="menuaddnad"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="itemdata.next_annuity_date"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    next_annuity_date = parseDate(itemdata.next_annuity_date)
                  "
                  @blur="
                    next_annuity_date = parseDate(itemdata.next_annuity_date)
                  "
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  clearable
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="next_annuity_date"
                @input="menuaddnad = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3"></v-col>
        </v-row>
        <v-row justify="space-around" class="heightsize90formadvance">
          <v-col cols="12" sm="5" md="5">
            <h3>Next Renewal D/L</h3>
            <v-menu
              v-model="menuaddnrd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="itemdata.next_renewal"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    next_renewal = parseDate(itemdata.next_renewal)
                  "
                  @blur="next_renewal = parseDate(itemdata.next_renewal)"
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                  clearable
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="next_renewal"
                @input="menuaddnrd = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="1" md="1"></v-col>
          <v-col cols="12" sm="6" md="6">
            <h3>Latest Renewal Attended</h3>
            <v-menu
              v-model="menuaddlra"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  clearable
                  v-model="itemdata.last_renewal_att"
                  persistent-hint
                  hint="Format DD/MM/YYYY"
                  @keydown.enter="
                    last_renewal_att = parseDate(itemdata.last_renewal_att)
                  "
                  @blur="
                    last_renewal_att = parseDate(itemdata.last_renewal_att)
                  "
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  dense
                ></v-text-field>
              </template>

              <v-date-picker
                v-model="last_renewal_att"
                @input="menuaddlra = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row justify="space-around">
          <v-col cols="12" sm="3" md="3">
            <h3>Patent Status</h3>
            <v-autocomplete
              clearable
              @click:clear="
                $nextTick(() => {
                  itemdata.status = 0;
                })
              "
              v-model="itemdata.status"
              :items="patent_status_list"
              item-text="patent_status_name"
              item-value="patent_status_id"
              outlined
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="9" md="9">
            <h3>Remark</h3>
            <v-textarea
              v-model="itemdata.remark"
              multi-line
              outlined
              dense
              rows="3"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row justify="space-around">
          <v-col cols="12" sm="12" md="12">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3>
                  Upload File
                  <span class="red--text">(Support .pdf files only) </span>
                </h3>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12" style="margin-top: -15px;">
            <v-row align="start">
              <v-col cols="4" sm="4" md="3">
                <input
                  type="file"
                  accept="application/pdf,application/vnd.ms-excel"
                  multiple="multiple"
                  @change="previewMultiImage"
                  class="inputsize"
                  ref="filefile"
                  style="display: none"
                />
                <v-btn
                  :style="{
                    backgroundColor: '#254E58',
                    color: 'white',
                    width: '100%'
                  }"
                  class="widthbtnimagefile"
                  @click="$refs.filefile.click()"
                  elevation="7"
                >
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon
                  >Upload file</v-btn
                >
                <!-- <span v-if="filename.length > 0"> </span> -->
                <!-- {{ filename }} -->
              </v-col>
              <v-col cols="1" sm="1" md="1" class="text-right mt-1">
              </v-col>
              <v-col cols="7" sm="7" md="8" class="mt-4">
                <v-row  
                  v-for="(item, index) in image_list"    
                  :key="index"
                >
                  <span 
                    @click="popuppreviewfile(index)"
                    class="file-link"
                  >
                    {{ item.name }}
                  </span>  
                  <v-btn
                    icon
                    color="red"
                    @click="popupdeletefile(index)"
                    style="margin-top: -7px;"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                 
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <h3>
                  Upload Image
                  <span class="red--text"> (Support .jpeg .png)</span>
                </h3>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12" style="margin-top: -15px;">
            <v-row align="start">
              <v-col cols="4" sm="4" md="3">
                <input
                  type="file"
                  accept="image/.png.jpg"
                  @change="previewImage"
                  class="inputsize"
                  ref="fileimage"
                  style="display: none"
                />
                <v-btn
                  :style="{
                    backgroundColor: '#254E58',
                    color: 'white',
                    width: '100%'
                  }"
                  class="widthbtnimagefile"
                  @click="$refs.fileimage.click()"
                  elevation="7"
                >
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon
                  >Upload Image</v-btn
                >
              </v-col>
              <v-col cols="1" sm="1" md="1" class="text-right mt-1" />
              <v-col cols="7" sm="7" md="8" class="mt-4">
                <!-- <v-row  
                  v-for="(item, index) in image_list"    
                  :key="index"
                > -->
                <v-row v-if="imagename != ''">
                  <span 
                    @click="popuppreviewimage()"
                    class="file-link"
                  >
                    {{ imagename }}
                  </span>  
                  <v-btn
                    icon
                    color="red"
                    @click="popupdeleteimage()"
                    style="margin-top: -7px;"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-col>

        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          class="mr-3 buttongold"
          @click="saveItem('createAp')"
        >
          Save and create appointment
        </v-btn>
        <v-btn
          @click="saveItem('createPT')"
          width="100"
          class="mr-3 buttonblue"
          color="#112D32"
        >
          Save
        </v-btn>
        <v-btn to="/master-patent-list" depressed outlined width="100">
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <br />
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >Are you sure you want to delete this file?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDeleteimage" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >Are you sure you want to delete this image?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDeleteimage"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="deleteItemConfirmimage"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewfile" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewfile">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview PDF File</v-card-title
        >

        <!-- 
                               :src="pdfdata"
                              v-for="i in numPages"
                  :key="i"
                  :id="i"
                  :page="i" -->
        <div
          v-if="checkfileapreview"
          v-for="(item, index) in previewpopupfile2"
          :key="index"
        >
          <pdf
            :src="item"
            v-for="i in numPagespreview"
            :key="i"
            :id="i"
            :page="i"
          >
            <template slot="loading">
              loading content here...
            </template>
          </pdf>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewfile"
            >Cancel</v-btn
          >

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogpreviewimage" max-width="700px">
      <v-card>
        <v-card-title class="text-h5">
          <v-btn icon @click="closepreviewimage">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
          Preview Image</v-card-title
        >

        <v-img
          disabled
          :src="previewimage"
          class="grey lighten-2 mt-3 mb-5"
          aspect-ratio="1"
          contain
        >
        </v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closepreviewimage"
            >Cancel</v-btn
          >

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    />
    <SuccessDialogPush
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
      :link="link"
    />
  </v-container>
</template>

<script>
const moment = require('moment-timezone');
import api from "@/services/api";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import pdfvuer from "pdfvuer";
import {
  server,
  imagemasterTMUrl,
  filemasterTMUrl,
} from "@/services/constants";

export default {
  name: "MasterPatentAdd",
  components: { SuccessDialog, SuccessDialogPush, pdf: pdfvuer },
  data() {
    return {
      preview_list2: [],
      getpreview_list: [],
      image: null,
      previewimage: null,
      previewimageedit: null,
      image_list: [],
      preview_list: [],
      dialogpreviewimage: false,
      checkfileapreview: false,
      previewpopupfile: [],
      previewpopupfile2: [],
      dialogpreviewfile: false,
      dialogDelete: false,
      dialogDeleteimage: false,
      filename: [],
      imagename: "",
      load_bg: false,
      checkfileadd: false,
      checkimageadd: false,

      country_list: [],
      isShowPassword: false,
      fullPage: true,
      objecttype_list: [],
      contact_owner_list: [],
      contact_agent_list: [],
      contact_associate_list: [],
      menuadd: false,
      menuaddAppD: false,
      menuaddptd: false,
      menuaddpubd: false,
      menuadderdd: false,
      menuaddeaxmd: false,
      menuadderd: false,
      menuaddlapd: false,
      menuaddnad: false,
      menuaddnrd: false,
      menuaddlra: false,
      menuaddndd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogAdd: false,
      main_id: 0,
      mode_operation: "Create",
      date_of_application: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_patent: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_publishing: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      exam_request_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      exam_request_deadline: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      date_of_examination: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      next_deadline: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      last_annuity_paid: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      next_annuity_date: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      next_renewal: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      last_renewal_att: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      type_list: [
        { type_name: "Design", type_number: "1" },
        { type_name: "Invention", type_number: "2" },
        { type_name: "Petty", type_number: "3" },
        { type_name: "Invention / PCT", type_number: "4" },
      ],
      // eslint-disable-next-line prettier/prettier
      latest_list: [
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
      ],
      patent_status_list: [
        { patent_status_name: "Nil", patent_status_id: 1 },
        { patent_status_name: "Pending", patent_status_id: 2 },
        { patent_status_name: "Registered", patent_status_id: 3 },
        { patent_status_name: "Registration", patent_status_id: 4 },
        { patent_status_name: "Renewal Pending", patent_status_id: 5 },
        { patent_status_name: "Closed", patent_status_id: 6 },
      ],
      itemdata: {
        tm_type: 0,
        file_no: "",
        title: "",
        name_of_client: "",
        app_no: "",
        patent_no: "",
        city: "",
        owner_contact: 0,
        agent_contact: 0,
        associate_contact: 0,
        val_no: "",
        page_no: "",
        priority_number: "",
        status: 0,
        type: "",
        remark: "",
        dead_last_annuity_paid: "",
        client_ref: "",
        good_service: "",
        registration_condition: "",
        owner_address: "",
        agent_address: "",
        associate_address: "",
        date_of_patent: null,
        date_of_application: null,
        date_of_publishing: null,
        date_of_examination: null,
        next_renewal: null,
        last_renewal_att: null,
        next_deadline: null,
        exam_request_deadline: null,
        exam_request_date: null,
        next_annuity_date: null,
        last_annuity_paid: null,
      },
    };
  },
  async mounted() {
    await this.loaddataobjecttypeBygroupId();
    await this.loaddatacontactByContact_type_owner();
    await this.loaddatacontactByContact_type_agent();
    await this.loaddatacontactByContact_type_associate();
    await this.loaddata();
    await this.loaddatacountry();
    this.$hideLoader();
  },
  methods: {
    async popupdeletefile(index) {
      this.fileindex = index;
      this.dialogDelete = true;
    },
    async closeDelete() {
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async deleteItemConfirm() {
      console.log(this.image_list);
      this.preview_list2 = [];
      this.getpreview_list.splice(this.fileindex, 1);
      this.image_list.splice(this.fileindex, 1);
      await this.getPdfforAdd(this.getpreview_list);

      this.filename.splice(this.fileindex, 1);
      this.preview_list2 = this.preview_list;
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async popupdeleteimage() {
      this.dialogDeleteimage = true;
    },
    async closeDeleteimage() {
      this.dialogDeleteimage = false;
    },
    async deleteItemConfirmimage() {
      this.checkimageadd = false;
      this.image = null;
      this.previewimage = "";
      this.imagename = "";
      this.dialogDeleteimage = false;
    },
    async popuppreviewfile(fileindex) {
      let pdf_newTab = window.open("");
      pdf_newTab.document.write(
        "<html><head><title>pdf file</title></head><body><iframe title='MY title'  width='100%' height='100%' src='" +
          this.getpreview_list[fileindex] +
          "'></iframe></body></html>"
      );

      return;
    },
    async closepreviewfile() {
      this.dialogpreviewfile = false;
    },
    async popuppreviewimage() {
      const imageTab = window.open("");
      imageTab.document.write(`
        <html>
          <head>
            <title>Preview Image</title>
          </head>
          <body style="margin:0; display:flex; flex-direction:column; justify-content:center; align-items:center; height:100vh; background-color:#000;">
            <img src="${this.previewimage}" alt="Preview" style="max-width:100%; max-height:100%; margin-bottom:20px;" />
          </body>
        </html>
      `);
      return;
    },
    async closepreviewimage() {
      this.dialogpreviewimage = false;
    },
    previewImage: function(event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.previewimage = e.target.result;
          this.checkimageadd = true;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }

      this.imagename = this.image.name;
    },
    async previewMultiImage(event) {
      this.preview_list = [];
      // this.image_list = [];
      this.filename = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_list.push(e.target.result);
            this.preview_list.push(e.target.result);
          };
          if (input.files[index].type === "application/pdf") {
            this.image_list.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      await this.getPdfforAdd(this.getpreview_list);
      this.preview_list2 = this.preview_list;
      this.image_list.forEach((x) => {
        this.filename.push(x.name);
      });
      this.checkfileeadd = true;
    },
    reset: function() {
      this.image = null;
      this.previewimage = null;
      this.image_list = [];
      this.preview_list = [];
    },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = [];
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
      console.log(this.previewpopupfile);
    },
    async getPdfforAdd(item) {
      this.preview_list = [];
      let getfile = [];
      getfile = item;
      getfile.forEach((file, index) => {
        this.preview_list.push(pdfvuer.createLoadingTask(`${file}`));
      });
      this.preview_list.forEach((item, index) => {
        item.then((pdf) => {
          this.numPages = pdf.numPages;
          // window.onscroll = function() {
          //   changePage();
          //   stickyNav();
          // };
          // Get the offset position of the navbar
          // var sticky = $("#buttons")[0].offsetTop;
          // // Add the sticky class to the this.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
          // function stickyNav() {
          //   if (window.pageYOffset >= sticky) {
          //     $("#buttons")[0].classList.remove("hidden");
          //   } else {
          //     $("#buttons")[0].classList.add("hidden");
          //   }
          // }
          function changePage() {
            var i = 1,
              count = Number(pdf.numPages);
            do {
              if (
                window.pageYOffset >=
                  this.findPos(document.getElementById(i)) &&
                window.pageYOffset <=
                  this.findPos(document.getElementById(i + 1))
              ) {
                this.page = i;
              }
              i++;
            } while (i < count);
            if (
              window.pageYOffset >= this.findPos(document.getElementById(i))
            ) {
              this.page = i;
            }
          }
        });
      });
      this.checkfileadd = true;
    },
    handle_pdf_link: function(params) {
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    findPos(obj) {
      return obj.offsetTop;
    },

    async loaddata() {
      if (this.$route.params.masterpt_id) {
        this.mode_operation = "Update";
        this.main_id = this.$route.params.masterpt_id;

        const result = await api.getByIdMasterPT(this.main_id);
        const editItem = result.data;
        this.itemdata = editItem[0];
        this.itemdata.date_of_application = this.formatDate(
          this.itemdata.date_of_application
        );
        this.itemdata.date_of_patent = this.formatDate(
          this.itemdata.date_of_patent
        );
        this.itemdata.date_of_publishing = this.formatDate(
          this.itemdata.date_of_publishing
        );
        this.itemdata.exam_request_date = this.formatDate(
          this.itemdata.exam_request_date
        );
        this.itemdata.exam_request_deadline = this.formatDate(
          this.itemdata.exam_request_deadline
        );
        this.itemdata.date_of_examination = this.formatDate(
          this.itemdata.date_of_examination
        );
        this.itemdata.next_deadline = this.formatDate(
          this.itemdata.next_deadline
        );
        this.itemdata.last_annuity_paid = this.formatDate(
          this.itemdata.last_annuity_paid
        );
        this.itemdata.next_annuity_date = this.formatDate(
          this.itemdata.next_annuity_date
        );
        this.itemdata.next_renewal = this.formatDate(
          this.itemdata.next_renewal
        );
        this.itemdata.last_renewal_att = this.formatDate(
          this.itemdata.last_renewal_att
        );
        //console.log("testdata:")
        //console.log(editItem[0]);
        this.onSelectOwnerChange(editItem[0].owner_contact);
        this.onSelectAgentChange(editItem[0].agent_contact);
        this.onSelectAssociateChange(editItem[0].associate_contact);
      }
    },
    async loaddataobjecttypeBygroupId() {
      const result = await api.getObjectTypeByGroupId(2);
      //console.log(result.data);
      this.objecttype_list = result.data;
    },
    async loaddatacontactByContact_type_owner() {
      const result = await api.getContactByContactType(1);
      this.contact_owner_list = result.data;
      // console.log("contact_owner_list:");
      // console.log(this.contact_owner_list);
    },
    async loaddatacontactByContact_type_agent() {
      const result = await api.getContactByContactType(2);
      this.contact_agent_list = result.data;
    },
    async loaddatacontactByContact_type_associate() {
      const result = await api.getContactByContactType(3);
      this.contact_associate_list = result.data;
    },
    async loaddatacountry() {
      const result = await api.getAllCountry();
      this.country_list = result.data;
    },
    async saveItem(mode) {
      //console.log(this.itemdata)
      if (this.itemdata.tm_type == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Select Object Type",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (!this.itemdata.file_no) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Enter File No.",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (!this.itemdata.name_of_client) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please Enter Client Name",
          "text-h5 red--text text-center"
        );
        return;
      }
      //this.$showLoader();
      if (this.mode_operation == "Create") {
        console.log("saveItem:", "Create");
        this.itemdata.date_of_application = this.changeformatDatetoinsert(
          this.itemdata.date_of_application
        );
        this.itemdata.date_of_patent = this.changeformatDatetoinsert(
          this.itemdata.date_of_patent
        );
        this.itemdata.date_of_publishing = this.changeformatDatetoinsert(
          this.itemdata.date_of_publishing
        );
        this.itemdata.exam_request_date = this.changeformatDatetoinsert(
          this.itemdata.exam_request_date
        );
        this.itemdata.exam_request_deadline = this.changeformatDatetoinsert(
          this.itemdata.exam_request_deadline
        );
        this.itemdata.date_of_examination = this.changeformatDatetoinsert(
          this.itemdata.date_of_examination
        );
        this.itemdata.next_deadline = this.changeformatDatetoinsert(
          this.itemdata.next_deadline
        );
        this.itemdata.last_annuity_paid = this.changeformatDatetoinsert(
          this.itemdata.last_annuity_paid
        );
        this.itemdata.next_annuity_date = this.changeformatDatetoinsert(
          this.itemdata.next_annuity_date
        );
        this.itemdata.next_renewal = this.changeformatDatetoinsert(
          this.itemdata.next_renewal
        );
        this.itemdata.last_renewal_att = this.changeformatDatetoinsert(
          this.itemdata.last_renewal_att
        );
        //alert("testcreate");
        this.$showLoader();
        // console.log("saveItem:", JSON.stringify(this.itemdata));
        let formData = new FormData();
        formData.append(`file`, this.image);
        this.image_list.forEach((x, index) => {
          formData.append(`file`, x);
        });

        formData.append("tm_type", this.itemdata.tm_type);
        formData.append("file_no", this.itemdata.file_no);
        formData.append("title", this.itemdata.title);
        formData.append("name_of_client", this.itemdata.name_of_client);
        formData.append("app_no", this.itemdata.app_no);
        formData.append("patent_no", this.itemdata.patent_no);
        formData.append("city", this.itemdata.city);

        if (this.itemdata.owner_contact) {
          formData.append("owner_contact", this.itemdata.owner_contact);
        }

        if (this.itemdata.agent_contact) {
          formData.append("agent_contact", this.itemdata.agent_contact);
        }

        if (this.itemdata.associate_contact) {
          formData.append("associate_contact", this.itemdata.associate_contact);
        }

        formData.append("val_no", this.itemdata.val_no);
        formData.append("page_no", this.itemdata.page_no);
        formData.append("priority_number", this.itemdata.priority_number);
        formData.append("status", this.itemdata.status);
        formData.append("type", this.itemdata.type);
        formData.append("remark", this.itemdata.remark);
        formData.append(
          "dead_last_annuity_paid",
          this.itemdata.dead_last_annuity_paid
        );
        formData.append("client_ref", this.itemdata.client_ref);
        formData.append("good_service", this.itemdata.good_service);
        formData.append(
          "registration_condition",
          this.itemdata.registration_condition
        );
        formData.append("owner_address", this.itemdata.owner_address);
        formData.append("agent_address", this.itemdata.agent_address);
        formData.append("associate_address", this.itemdata.associate_address);
        if (this.itemdata.date_of_patent) {
          formData.append("date_of_patent", this.itemdata.date_of_patent);
        }
        if (this.itemdata.date_of_application) {
          formData.append(
            "date_of_application",
            this.itemdata.date_of_application
          );
        }

        if (this.itemdata.date_of_publishing) {
          formData.append(
            "date_of_publishing",
            this.itemdata.date_of_publishing
          );
        }

        if (this.itemdata.date_of_examination) {
          formData.append(
            "date_of_examination",
            this.itemdata.date_of_examination
          );
        }

        if (this.itemdata.next_renewal) {
          formData.append("next_renewal", this.itemdata.next_renewal);
        }

        if (this.itemdata.last_renewal_att) {
          formData.append("last_renewal_att", this.itemdata.last_renewal_att);
        }

        if (this.itemdata.next_deadline) {
          formData.append("next_deadline", this.itemdata.next_deadline);
        }

        if (this.itemdata.exam_request_deadline) {
          formData.append(
            "exam_request_deadline",
            this.itemdata.exam_request_deadline
          );
        }

        if (this.itemdata.exam_request_date) {
          formData.append("exam_request_date", this.itemdata.exam_request_date);
        }

        if (this.itemdata.next_annuity_date) {
          formData.append("next_annuity_date", this.itemdata.next_annuity_date);
        }

        if (this.itemdata.last_annuity_paid) {
          formData.append("last_annuity_paid", this.itemdata.last_annuity_paid);
        }

        // const create_masterpt = await api.createMasterPT(this.itemdata);
        const create_masterpt = await api.createMasterPT_V2(formData);
        this.$hideLoader();
        //console.log(create_masterpt.data);
        //alert(create_masterpt.data.file_no);
        if (create_masterpt.status == 203) {
          if (create_masterpt.data.file_no) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "data duplicate ",
              "please check File No.",
              "text-h5 red--text text-center"
            );
            return;
          }
          if (create_masterpt.data.app_no) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "data duplicate ",
              "please check Application No.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }
        if (create_masterpt.status == 200 || create_masterpt.status == 201) {
          
          this.$showLoader();
          let dataAdd = {
              user_id: localStorage.getItem(server.USER_ID),
              log_in_out_id: localStorage.getItem(server.LOGIN_ID),
              action: "Create",
              table_name: "masterpt",
              table_id: create_masterpt.data.masterpt_id,
              date: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
          }

          await api.addTransectionLog(dataAdd)

          var dataEditLog = {
              last_update: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
          }
          await api.updateLogInOutLog(localStorage.getItem(server.LOGIN_ID),dataEditLog)
          
          this.$hideLoader();
          if(mode == "createAp"){
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              `/appointment-patent-add/${this.itemdata.file_no}`
            );
          }else{
            this.$store.state.global_push_dialog = true;
            this.setupAlertDialogPush(
              true,
              "save data",
              "save data success",
              "text-h5 green--text text-center",
              "/master-patent-list"
            );
          }
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "save data",
            "can't save data",
            "text-h5 red--text text-center"
          );
        }
      }
      if (this.mode_operation == "Update") {
        this.itemdata.date_of_application = this.changeformatDatetoinsert(
          this.itemdata.date_of_application
        );
        this.itemdata.date_of_patent = this.changeformatDatetoinsert(
          this.itemdata.date_of_patent
        );
        this.itemdata.date_of_publishing = this.changeformatDatetoinsert(
          this.itemdata.date_of_publishing
        );
        this.itemdata.exam_request_date = this.changeformatDatetoinsert(
          this.itemdata.exam_request_date
        );
        this.itemdata.exam_request_deadline = this.changeformatDatetoinsert(
          this.itemdata.exam_request_deadline
        );
        this.itemdata.date_of_examination = this.changeformatDatetoinsert(
          this.itemdata.date_of_examination
        );
        this.itemdata.next_deadline = this.changeformatDatetoinsert(
          this.itemdata.next_deadline
        );
        this.itemdata.last_annuity_paid = this.changeformatDatetoinsert(
          this.itemdata.last_annuity_paid
        );
        this.itemdata.next_annuity_date = this.changeformatDatetoinsert(
          this.itemdata.next_annuity_date
        );
        this.itemdata.next_renewal = this.changeformatDatetoinsert(
          this.itemdata.next_renewal
        );
        this.itemdata.last_renewal_att = this.changeformatDatetoinsert(
          this.itemdata.last_renewal_att
        );
        // date_of_application: new Date(
        // date_of_patent: new Date(
        // date_of_publishing: new Date(
        // exam_request_date: new Date(
        // exam_request_deadline: new Date(
        // date_of_examination: new Date(
        // next_deadline: new Date(
        // last_annuity_paid: new Date(
        // next_annuity_date: new Date(
        // next_renewal: new Date(
        // last_renewal_att: new Date(
        this.$showLoader();
        const update_masterpt = await api.updateMasterPt(
          this.main_id,
          this.itemdata
        );
        await api.AppointmentUpdateclientname(this.itemdata.file_no, {
          trademark_name: this.itemdata.name_of_client,
        });
        this.$hideLoader();
        //console.log(update_masterpt);
        if (update_masterpt.status == 203) {
          if (update_masterpt.data.file_no) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "data duplicate ",
              "please check File No.",
              "text-h5 red--text text-center"
            );
            return;
          }
          if (update_masterpt.data.app_no) {
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "data duplicate ",
              "please check Application No.",
              "text-h5 red--text text-center"
            );
            return;
          }
        }
        if (update_masterpt.status == 200 || update_masterpt.status == 201) {
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "save data",
            "save data success",
            "text-h5 green--text text-center",
            "/master-patent-list"
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "save data",
            "can't save data",
            "text-h5 red--text text-center"
          );
        }
      }
      //this.$hideLoader();
    },
    async onSelectOwnerChange(id) {
      //alert(id);
      this.contact_owner_list.filter((item) => {
        if (item.contact_id == id) {
          this.owner_address =
            item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    async onSelectAgentChange(id) {
      this.contact_agent_list.filter((item) => {
        if (item.contact_id == id) {
          this.agent_address =
            item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    async onSelectAssociateChange(id) {
      this.contact_associate_list.filter((item) => {
        if (item.contact_id == id) {
          this.associate_address =
            item.address + " " + item.city + " " + item.country;
          return item;
        }
      });
    },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("/");
      return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    //console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },

  watch: {
    show: function(s) {
      if (s) {
        this.getPdf();
      }
    },
    page: function(p) {
      if (
        window.pageYOffset <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    },
  },
  watch: {
    date_of_application(val) {
      this.itemdata.date_of_application = this.formatDate(
        this.date_of_application
      );
    },
    date_of_patent(val) {
      this.itemdata.date_of_patent = this.formatDate(this.date_of_patent);
    },
    date_of_publishing(val) {
      this.itemdata.date_of_publishing = this.formatDate(
        this.date_of_publishing
      );
    },
    exam_request_date(val) {
      this.itemdata.exam_request_date = this.formatDate(this.exam_request_date);
    },
    exam_request_deadline(val) {
      this.itemdata.exam_request_deadline = this.formatDate(
        this.exam_request_deadline
      );
    },
    date_of_examination(val) {
      this.itemdata.date_of_examination = this.formatDate(
        this.date_of_examination
      );
    },
    next_deadline(val) {
      this.itemdata.next_deadline = this.formatDate(this.next_deadline);
    },
    last_annuity_paid(val) {
      this.itemdata.last_annuity_paid = this.formatDate(this.last_annuity_paid);
    },
    next_annuity_date(val) {
      this.itemdata.next_annuity_date = this.formatDate(this.next_annuity_date);
    },
    next_renewal(val) {
      this.itemdata.next_renewal = this.formatDate(this.next_renewal);
    },
    last_renewal_att(val) {
      this.itemdata.last_renewal_att = this.formatDate(this.last_renewal_att);
    },
  },
};
</script>

<style scoped>
.file-link {
  cursor: pointer;
  color: blue;
  transition: color 0.2s ease;
}

.file-link:hover {
  color: gray;
}
.text-left {
  color: aliceblue;
}
.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}
.v-autocomplete.v-input > .v-input__control > .v-input__slot {
  min-height: 10px;
}
.widthsizeformadvance {
  width: 60%;
}

.bd-block-tb {
  border-block: 1px solid gray;
  writing-mode: horizontal-tb;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}
.bd-block-lr {
  border-block: 1px solid gray;
  writing-mode: vertical-lr;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}
.widthsize80formadvance {
  width: 80%;
}
.heightsize55formadvance {
  height: 55px;
}

.heightsize80performadvance {
  height: 60%;
}

.heightsize90formadvance {
  height: 90px;
}

.heightsizemultiCo {
  height: 190px;
}
.heightsizemultiCo180 {
  height: 180px;
}

.heightsizemultiCo200 {
  height: 200px;
}

.widthsize8055formadvance {
  width: 80px;
  height: 55px;
}

.advance-text-height {
  height: 70px;
}

.some-other-style {
  background: blue;
}
.my-header-style {
  color: #ffffff !important;
  background: #515151;
}

.data-table-button {
  color: #9e3b1b;
}

.my-header2-style {
  color: #ffffff !important;
  background: #515151;
  width: 120px;
}

.my-header3-style {
  color: #ffffff !important;
  background: #515151;
  width: 80px;
}

.my-header4-style {
  color: #ffffff !important;
  background: #515151;
  width: 150px;
}
.btnuploadfile {
  border: 2px solid;
}

.widthbtnimagefile {
  width: 40%;
}
.widthsizesearch {
  width: 80px;
}
.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}
.btnuploadfile {
  border: 2px solid;
}
h5 {
  color: #737373;
}
.vali {
  color: red;
}

h3 {
  font-size: 1.17em;
}
.v-btn:not(.v-btn--round).v-size--default.buttongold {
  background-color: #464231;
  color: white;
}
</style>
